import { useTranslation } from 'next-i18next'
import { TableHead, TableHeader, TableRow } from '~/components/ui/table'

export const InvoicesTableHeader = () => {
	const { t } = useTranslation()

	return (
		<TableHeader>
			<TableRow className='divide-x divide-dashed divide-border/75'>
				<TableHead className='w-[100px]'>
					{t('myAccountInvoices:tableHeader.date')}
				</TableHead>

				<TableHead>{t('myAccountInvoices:tableHeader.ref')}</TableHead>

				<TableHead>
					{t('myAccountInvoices:tableHeader.reservationRef')}
				</TableHead>

				<TableHead className='w-[150px]'>
					{t('myAccountInvoices:tableHeader.status')}
				</TableHead>

				<TableHead className='w-[150px]'>
					{t('myAccountInvoices:tableHeader.total')}
				</TableHead>

				<TableHead className='w-[50px]' />
			</TableRow>
		</TableHeader>
	)
}
